<template>
  <div>
    <h1>Login</h1>
    {{ status }}
    <form @submit.prevent="doLogin()">
      <input type="text" v-model="username" placeholder="username" />
      <input type="text" v-model="password" placeholder="password" />
      <!-- <input type="submit" value="Login" /> -->
      <button type="submit">Login</button>
    </form>
    <router-link to="signup">Don't have an account?</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      status: "",
    };
  },
  methods: {
    doLogin() {
      const hash = this.makeHash();
      this.axios
        .get("secure", {
          headers: {
            Authorization: hash,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            // save username and password
            localStorage.setItem("user", hash);

            this.startRedirect();
          }
        })
        .catch((response) => {
          if (response.toString().includes("401")) {
            // show error
            this.status = "Invalid password";

            // remove error after sometime
            setTimeout(() => {
              this.status = "";
            }, 5000);
          }
        });
    },
    makeHash() {
      const detail = btoa(`${this.username}:${this.password}`);
      return `Basic ${detail}`;
    },
    startRedirect() {
      // redirect
      const next = this.$route.query.next;
      if (next) {
        this.$router.push(next);
      } else {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    localStorage.removeItem("user");
  },
};
</script>

<style lang="scss" scoped>
div {
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    input {
      width: 200px;
      height: 20px;
      margin: 10px;
      padding: 3px;
      text-align: center;
    }
    button {
      width: 100px;
      margin: 10px;
      padding: 5px;
      font-weight: normal;
      font-size: 1em;
      letter-spacing: 0.5px;
      border: 1px transparent;
      border-radius: 5px;
      color: #f7f7f7;
      background-color: #2c3e50;
    }
  }
  a{
    text-decoration: none;
    color:#2c3e50;
    padding:5px;
  }
}
</style>
